import { ME } from "../constants";

export const saveMeInfo = (info: any) => {
  return {
    type: ME,
    info,
  };
};
